<div
  #switchEl
  role="switch"
  [attr.aria-checked]="checked"
  [attr.aria-invalid]="invalid"
  [attr.aria-required]="required"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledBy"
  [class.disabled]="isDisabled"
  tabindex="0"
  (click)="toggleSwitch()"
  (keydown.space)="toggleSwitch()"
  (keydown.enter)="toggleSwitch()"
  (blur)="handleOnTouch($event)"
>
  <div class="switch-box">
    <div></div>
  </div>

  <span>
    <ng-content></ng-content>
  </span>

  <input type="hidden" [name]="name" [value]="checked">
</div>
